import { ContactField } from 'src/editor/api/contact-fields-api'
import { contactFieldLocoKeys } from 'src/shared/constants/contact-field-loco-keys'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'
import { TypedTFunctionInterface } from 'src/shared/i18next/types/typed-t-function-interface'

export const getContactSlugName = (
  slug: ContactSlugEnum,
  t: TypedTFunctionInterface,
) => t(contactFieldLocoKeys[slug])

export const getContactFieldTitle = (
  contactField: Pick<ContactField, 'fieldName' | 'slug'>,
  t: TypedTFunctionInterface,
) => {
  const { slug, fieldName } = contactField

  if (Object.values(ContactSlugEnum).includes(slug as ContactSlugEnum)) {
    return getContactSlugName(slug as ContactSlugEnum, t)
  }

  return fieldName
}
